module.exports = __webpack_public_path__ + "static/media/view6.3bc3b39a.jpg";